"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = function _default(value) {
  return value.length === 0;
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/isEmpty.js
// module id = 639
// module chunks = 0